import React, { useContext, useEffect, useState } from 'react';
import { Select, SIZE } from 'baseui/select';
import { Button } from 'baseui/button';
import AuthContext from '../shared/AuthContext';
import { invalidateRealtime } from '../../realtime/realtimeBus';

const VISIBILITY_OPTIONS = [
  { label: 'Public — show name on leaderboard', id: 'PUBLIC' },
  { label: 'Anonymous — masked name', id: 'ANONYMOUS' },
  { label: 'Hidden — do not appear on leaderboard', id: 'HIDDEN' },
];

export default function GamificationSettingsPanel({ onMessage, embedded = false }) {
  const { apiClient } = useContext(AuthContext);
  const [visibility, setVisibility] = useState([VISIBILITY_OPTIONS[0]]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await apiClient.get('/api/gamification/summary');
        const v = res.data?.leaderboardVisibility || 'PUBLIC';
        const opt = VISIBILITY_OPTIONS.find((o) => o.id === v) || VISIBILITY_OPTIONS[0];
        setVisibility([opt]);
      } catch {
        /* ignore */
      } finally {
        setLoading(false);
      }
    })();
  }, [apiClient]);

  const save = async () => {
    try {
      await apiClient.patch('/api/gamification/preferences', {
        leaderboardVisibility: visibility[0]?.id || 'PUBLIC',
      });
      invalidateRealtime('gamification-preferences');
      onMessage?.('Gamification preferences saved.');
    } catch {
      onMessage?.('Could not save gamification preferences.');
    }
  };

  if (loading) return null;

  const body = (
    <>
      <h2 className={embedded ? 'settings-subheading' : undefined}>Leaderboard &amp; progress</h2>
      <p className="settings-muted">Control public ranking visibility. Learning score and XP always remain private to you.</p>
      <div className="settings-field settings-field--wide">
        <label htmlFor="leaderboard-visibility">Leaderboard visibility</label>
        <Select
          inputId="leaderboard-visibility"
          options={VISIBILITY_OPTIONS}
          value={visibility}
          onChange={({ value }) => setVisibility(value)}
          size={SIZE.compact}
          clearable={false}
          maxDropdownHeight="240px"
        />
      </div>
      <div className="settings-actions">
        <Button onClick={save}>Save visibility</Button>
      </div>
    </>
  );

  if (embedded) {
    return <div className="settings-gamification-block">{body}</div>;
  }

  return <section className="settings-card">{body}</section>;
}
